import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { EffectCreative } from 'swiper/modules';
import { logPlugin } from '@babel/preset-env/lib/debug';

function rcAnimations() {
  const currentURL = window.location.href;

  if (currentURL.includes('/products/')) {
    document.addEventListener('DOMContentLoaded', function () {
      bannerAnimations();
      circleAnimations();
    });

    let isClicking = false;
    const svgElement = document.querySelector('.circle-svg svg');
    const svgGroups = svgElement.querySelectorAll(
      '#scroll-element-v10 > g[data-index]'
    );

    window.addEventListener('load', function () {
      if (window.innerHeight < 666) return;

      const triggerElement = document.querySelectorAll('.click-trigger-el');
      const cards = document.querySelectorAll('.circle-content');
      const cardsCount = cards.length;

      triggerElement.forEach((trigger) => {
        trigger.style.cursor = 'pointer';
      });

      if (cardsCount === 0) return;

      const initScrollMarkers = () => {
        const existing = document.querySelectorAll('.scroll-marker');
        if (existing && existing.length > 0) {
          existing.forEach((marker) => marker.remove());
        }
        const element = document.querySelector('.pin-spacer');
        const totalHeight = element.getBoundingClientRect().height;

        let step;
        if (cardsCount === 4) {
          step = totalHeight / (cardsCount - 1) / 1.21;
        } else if (cardsCount === 5) {
          step = totalHeight / (cardsCount - 1) / 1.2;
        } else {
          step = totalHeight / (cardsCount - 1) / 1.18;
        }

        for (let i = 0; i < cardsCount; i++) {
          const marker = document.createElement('div');
          marker.classList.add('scroll-marker');
          marker.setAttribute('data-index', i);
          marker.style.position = 'absolute';

          let topValue = step * i;

          if (i === 0) {
            topValue += 200;
          }

          if ((cardsCount === 4 || cardsCount === 5) && i === cardsCount - 1) {
            topValue -= 250;
          }

          marker.style.top = `${topValue}px`;

          marker.style.width = '100%';
          marker.style.visibility = 'hidden';
          marker.style.opacity = '0';

          element.appendChild(marker);
        }
      };
      initScrollMarkers();
      let resizeTimer;

      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          initScrollMarkers();
        }, 200);
      });

      document.addEventListener('click', function (event) {
        if (isClicking) return;
        const trigger = event.target.closest('.click-trigger-el');

        if (trigger) {
          const targetId = trigger.getAttribute('data-index');
          const targetMarker = document.querySelector(
            `.scroll-marker[data-index="${targetId}"]`
          );

          if (targetMarker) {
            isClicking = true;
            targetMarker.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });

            trigger.classList.remove('active-remove-js');

            document.querySelectorAll('.click-trigger-el').forEach((el) => {
              if (el !== trigger) {
                el.classList.add('active-remove-js');
              }
            });

            setTimeout(() => {
              isClicking = false;
            }, 500);
          }
        }
      });

      window.addEventListener('scroll', () => {
        if (!isClicking) {
          svgGroups.forEach((group) => {
            group.classList.remove('active-remove-js');
          });
        }
      });
    });

    function circleAnimations() {
      if (currentURL.includes('/products/')) {
        gsap.registerPlugin(ScrollTrigger);

        const texts = document.querySelectorAll('#Group_1 text');
        const isSafari = document.body.classList.contains('e--ua-safari');

        texts.forEach((text) => {
          if (!text.hasAttribute('text-anchor')) {
            text.setAttribute('text-anchor', 'middle');
          }
        });

        const pageData = {
          'assessed/': {
            labels: [
              'Primary &|Middle School',
              'Upper|Secondary|School',
              'Parents',
              'Tutors',
              'Home|School',
              'School|Integration',
            ],
            fillColors: [
              '#DC143C',
              '#DC143C',
              '#DC143C',
              '#DC143C',
              '#DC143C',
              '#DC143C',
            ],
            svg: [
              '#svg-revise-online',
              '#svg-assessed',
              '#svg-preped',
              '#svg-sharpened',
              '#svg-none',
              '#svg-choiced',
            ],
            svgPositions: { baseY: 50, x: '53%' },
            defaultColor: '#716D6D',
          },
          'calced/': {
            labels: ['VCE', 'WACE', 'QCE', 'HSC'],
            fillColors: ['#6E0D71', '#6E0D71', '#6E0D71', '#6E0D71'],
            svg: [
              '#svg-assessed',
              '#svg-sharpened',
              '#svg-preped',
              '#svg-none',
            ],
            svgPositions: { baseY: 50, x: '50%' },
            defaultColor: '#708090',
          },
          'connected/': {
            labels: [
              'Primary &|Middle School',
              'Upper|Secondary|School',
              'Home|School',
              'Professional|Development',
            ],
            fillColors: ['#5243A0', '#5243A0', '#5243A0', '#5243A0'],
            svg: [
              '#svg-assessed',
              '#svg-sharpened',
              '#svg-preped',
              '#svg-none',
            ],
            svgPositions: { baseY: 0, x: '4%' },
            defaultColor: '#E6E4FD',
          },
          'preped/': {
            labels: [
              'Leaving|Exams',
              'Professional|Development',
              'School|Integration',
              'Literacy &|Numeracy',
              'Scholarships',
            ],
            fillColors: ['#008080', '#008080', '#008080', '#008080', '#008080'],
            svg: [
              '#svg-sharpened',
              '#svg-none',
              '#svg-preped',
              '#svg-choiced',
              '#svg-assessed',
            ],
            svgPositions: { baseY: 54, x: '57%' },
            defaultColor: '#BD577B',
          },
          'selected/': {
            labels: [
              'Parents',
              'Scholarships',
              'Upper|Secondary|Schools',
              'Tutors',
            ],
            fillColors: ['#C5541B', '#C5541B', '#C5541B', '#C5541B'],
            svg: [
              '#svg-assessed',
              '#svg-sharpened',
              '#svg-preped',
              '#svg-none',
            ],
            svgPositions: { baseY: 50, x: '50%' },
            defaultColor: '#016A61',
          },
        };

        const animationContainer = document.getElementById(
          'animation-container'
        );
        const cards = document.querySelectorAll('.circle-content');

        if (!animationContainer || !cards || !cards.length || !svgElement)
          return;

        const center = svgElement.querySelector('#center');
        let labels, fillColors, svg, svgPositions, defaultColor;

        Object.keys(pageData).forEach((key) => {
          if (currentURL.includes(key)) {
            labels = pageData[key].labels;
            fillColors = pageData[key].fillColors;
            svg = pageData[key].svg;
            svgPositions = pageData[key].svgPositions;
            defaultColor = pageData[key].defaultColor;
          }
        });

        if (center) center.style.fill = fillColors[0];

        function getYValue(index, baseY, pipeCount) {
          return baseY - pipeCount * 2;
        }

        function updateSVGText(index) {
          const textBlock = document.querySelector('#Mask_Group_1 text');
          textBlock.style.opacity = 1;
          const svgTextElement = document.querySelector('.circle-svg text');
          svgTextElement.textContent = '';
          const currentLabel = labels[index];
          const pipeCount = (currentLabel.match(/\|/g) || []).length;
          const { baseY, x } = svgPositions;

          const newY = getYValue(index, baseY, pipeCount);
          svgTextElement.setAttribute('y', `${newY}%`);

          const lines = currentLabel.split('|');
          lines.forEach((line, i) => {
            const tspan = document.createElementNS(
              'http://www.w3.org/2000/svg',
              'tspan'
            );
            tspan.setAttribute('x', x);
            tspan.setAttribute('y', `${newY}%`);
            tspan.setAttribute('dy', `${i * 1.2}em`);
            tspan.textContent = line.trim();
            svgTextElement.appendChild(tspan);
          });
        }

        const mm = gsap.matchMedia();

        mm.add('(min-height: 666px)', () => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: '#animation-container',
              pin: true,
              scrub: true,
              start: 'center-=60 center',
              end: () => `+=${window.innerHeight * (cards.length - 1)}`,
              markers: false, // remove in production
            },
          });

          function updateCircle(index) {
            if (index < 0) index = 0;
            updateSVGText(index);
          }

          function toggleSvg(index, active = true) {
            if (index < 0) return;

            const group = svgElement.querySelector(svg[index]);
            if (!group) return;

            const fillColor = group.querySelector('path');
            const fillWhite = group.querySelectorAll('g path');
            const circle = group.querySelectorAll('circle, ellipse');
            const text = group.querySelectorAll('text');

            if (active) {
              group.classList.add('active-js');

              gsap.to(fillColor, { fill: fillColors[index], duration: 0.5 });
              fillWhite.forEach(
                (el) =>
                  fillColor !== el &&
                  gsap.to(el, { fill: '#ffffff', duration: 0.5 })
              );
              text.forEach((el) =>
                gsap.to(el, { fill: '#ffffff', duration: 0.5 })
              );
              circle.forEach((el) =>
                gsap.to(el, {
                  fill: fillColors[index],
                  stroke: '#ffffff',
                  duration: 0.5,
                })
              );
            } else {
              group.classList.remove('active-js');

              gsap.to(fillColor, { fill: defaultColor, duration: 0.2 });
              fillWhite.forEach((el) =>
                gsap.to(el, { fill: defaultColor, duration: 0.5 })
              );
              text.forEach((el) =>
                gsap.to(el, { fill: defaultColor, duration: 0.5 })
              );
              circle.forEach((el) =>
                gsap.to(el, {
                  fill: '#ffffff',
                  stroke: defaultColor,
                  duration: 0.5,
                })
              );
            }
          }

          cards.forEach((card, i) => {
            card.setAttribute('data-index', i);

            if (i > 0) {
              tl.to(cards[i - 1], {
                opacity: 0,
                visibility: 'hidden',
                duration: 0.2,
                ease: 'power2.out',
              });
            }

            tl.fromTo(
              card,
              {
                opacity: 0,
                visibility: 'hidden',
                transformOrigin: 'center center',
              },
              {
                opacity: 1,
                visibility: 'visible',
                duration: 5,
                ease: 'power2.out',
                transformOrigin: 'center center',
                onStart: () => {
                  toggleSvg(i);
                  toggleSvg(i - 1, false);
                  updateCircle(i);
                },
                onReverseComplete: () => {
                  toggleSvg(i, false);
                  toggleSvg(i - 1, i - 1 >= 0);
                  updateCircle(i - 1 >= 0 ? i - 1 : 0);
                },
              },
              '-=0.3'
            );
          });
        });

        mm.add('(max-height: 665px)', () => {
          cards.forEach((card) => {
            gsap.set(card, {
              visibility: 'visible',
              opacity: 1,
              position: 'static',
              transform: 'none',
            });
          });
        });
      }
    }

    function bannerAnimations() {
      // Define gradient and base color sets for each page
      const pageColors = {
        '/products/assessed/': {
          gradients: [
            'radial-gradient(circle, #DC143C 0%, #4E0715 100%)',
            'radial-gradient(circle, #CECECE 0%, #A9A9A9 100%)',
            'radial-gradient(circle, #00989A 0%, #00CED1 100%)',
          ],
          baseColors: ['#DC143C', '#CECECE', '#00989A'],
        },
        '/products/calced/': {
          gradients: [
            'radial-gradient(circle, #6E0D71 0%, #560A58 100%)',
            'radial-gradient(circle, #667685 0%, #414B55 100%)',
            'radial-gradient(circle, #377E9A 0%, #476A78 100%)',
          ],
          baseColors: ['#6E0D71', '#708090', '#87CEEB'],
        },
        '/products/sharpened/': {
          gradients: [
            'radial-gradient(circle, #4169E1 0%, #3454B4 100%)',
            // 'radial-gradient(circle, #708090 0%, #4F5B67 100%)',
            // 'radial-gradient(circle, #FFA500 0%, #476A78 100%)'
          ],
          baseColors: ['#4169E1', '#708090', '#FFA500'],
        },
        '/products/connected/': {
          gradients: ['radial-gradient(circle, #5243A0 0%, #3A2F74 100%)'],
          // baseColors: ['#455378'],
        },
        '/products/preped/': {
          gradients: [
            'radial-gradient(circle, #008080 0%, #016A6A 100%)',
            'radial-gradient(circle, #C0597D 0%, #6E1937 100%)',
            'radial-gradient(circle, #CC5500 0%, #874617 100%)',
          ],
          baseColors: ['#008080', '#BD577B', '#CC5500'],
        },
        '/products/selected/': {
          gradients: [
            'radial-gradient(circle, #E5743D 0%, #8D4B2B 100%)',
            'radial-gradient(circle, #016A61 0%, #00433D 100%)',
            'radial-gradient(circle, #455378 0%, #1C2746 100%)',
          ],
          baseColors: ['#E5743D', '#016A61', '#455378'],
        },

        // Add more pages as needed
      };

      // Get the current page's path
      const currentPage = window.location.pathname;
      // console.log('Current Page Path:', currentPage);

      // Set default gradients and baseColors or use those from pageColors
      const { gradients, baseColors } = pageColors[currentPage] || {
        gradients: ['radial-gradient(circle, #CCCCCC 0%, #333333 100%)'],
        baseColors: ['#CCCCCC'],
      };

      // Main index to keep track of the current color set
      let mainIndex = 0;

      const bgAnimation = document.querySelector('.bg-animation');
      const bannerButtonText = document.querySelector(
        '.text-animation .elementor-button-text'
      );

      // Variables to manage text flip animation
      const flipTexts = document.querySelectorAll('.flip-text');
      const flipTextWrapper = document.querySelector('.flip-text-wrapper');
      let currentIndex = 0;

      // Initialize the first text
      flipTexts[currentIndex].style.opacity = 1;
      flipTexts[currentIndex].style.display = 'block';
      flipTextWrapper.style.width = `${flipTexts[currentIndex].offsetWidth}px`;

      // Initialize Swiper
      Swiper.use([EffectCreative]);
      const bannerSwiper = new Swiper('.banner-swiper', {
        direction: 'vertical',
        loop: true,
        autoHeight: true,
        autoplay: false,
        speed: 700,
        allowTouchMove: false,
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: false,
            origin: 'center bottom',
            translate: ['0%', 180, 0],
            opacity: 0,
          },
          next: {
            origin: 'center bottom',
            translate: ['0%', 180, 0],
            opacity: 0,
          },
        },
      });

      // Function to handle background and text color cycling
      function cycleBackgroundAndText() {
        bgAnimation.style.backgroundImage = gradients[mainIndex];
        bannerButtonText.style.color = baseColors[mainIndex];
      }

      // Function to animate the flip text
      function animateFlipTexts() {
        const currentText = flipTexts[currentIndex];
        gsap.to(currentText, {
          rotationX: -90,
          duration: 0.5,
          onComplete: () => {
            currentText.style.opacity = 0;
            currentText.style.display = 'none';

            currentIndex = (currentIndex + 1) % flipTexts.length;
            const nextText = flipTexts[currentIndex];

            flipTexts.forEach((text) => (text.style.display = 'none'));
            nextText.style.opacity = 1;
            nextText.style.display = 'block';

            flipTextWrapper.style.width = `${nextText.offsetWidth}px`;

            gsap.fromTo(
              nextText,
              { rotationX: 90, opacity: 0 },
              {
                rotationX: 0,
                opacity: 1,
                duration: 0.5,
              }
            );
          },
        });
      }

      function startAnimation() {
        gsap.to(
          '.text-animation h1, h2:has(.flip-text-wrapper), .text-animation .bb-elementor-custom-color',
          {
            keyframes: [
              { color: '#FFF', duration: 0 }, // Start at #FFF
              { color: baseColors[mainIndex], duration: 1 }, // Transition to the color at mainIndex
              { color: '#FFF', duration: 1 }, // Return to #FFF over 2s
            ],
          }
        );
      }

      function triggerFlashAnimation() {
        const flashElement = document.querySelector('.flash');
        if (!flashElement) return;
        const parentWidth = flashElement.parentElement.offsetWidth;
        const flashWidth = flashElement.offsetWidth;

        // Calculate left position to center the element on the x-axis
        const leftPosition = (parentWidth - flashWidth) / 2;
        flashElement.style.left = `${leftPosition}px`;

        // Remove the class to reset the animation (if it's already applied)
        flashElement.classList.remove('flash-animation');

        // Force a reflow to restart the animation
        void flashElement.offsetWidth;

        // Re-add the class to trigger the animation
        flashElement.classList.add('flash-animation');
      }

      let startTime = null;
      let animationDuration = 4000; // 4 seconds per cycle
      let animationFrame;

      // Main animation loop using requestAnimationFrame
      function animate(timestamp) {
        if (!startTime) startTime = timestamp; // Initialize start time
        let progress = timestamp - startTime;

        if (progress >= animationDuration) {
          // Sync the animations
          mainIndex = (mainIndex + 1) % gradients.length;
          cycleBackgroundAndText();
          animateFlipTexts();
          bannerSwiper.slideNext();
          startAnimation();
          triggerFlashAnimation();
          startTime = timestamp; // Reset the start time for the next cycle
          // console.log('animations triggered');
        }

        // Continue the loop
        animationFrame = requestAnimationFrame(animate);
      }

      // Start the animation loop initially
      animationFrame = requestAnimationFrame(animate);

      // Handle tab visibility changes
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          // Cancel the animation loop when tab is inactive
          cancelAnimationFrame(animationFrame);
        } else {
          // Restart the animation when tab becomes active again
          startTime = null; // Reset the start time
          animationFrame = requestAnimationFrame(animate); // Restart the loop
        }
      });
    }
  }
}

rcAnimations();
